// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wOKe","col":"styles_col__3zak7"};